import { actionTypes } from '../../constants/actionTypes';

const initState = {
	data: {},
	error: null,
	loading: true
};

export default function (state = initState, action) {
	const { type, payload } = action;
	switch (type) {
		case actionTypes.FETCH_WP_ONE_STORE: {
			return Object.assign({}, state, { data: {}, loading: true });
		}

		case actionTypes.FETCH_WP_STORE_ONE_SUCCESS:
		case actionTypes.FETCH_WP_STORE_ONE_FAIL: {
			return Object.assign({}, state, payload);
		}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/stores/storeOneWP.tsx